import React from 'react';
import './Featured.css';

export default function () {
  return (
    <div className="Featured">
      <h2>FEATURED</h2>
      <a
        className="selectable"
        href="https://jadeallencook.github.io/px-art/build/#0000011111100000000111022011100000110002200011000112002222002110010222222222201011002200002200111000200000020001100020000002000110002000000200011222220000222221122111111111122111110010010011110110001001000110001000000000010000110000000011000001111111111000"
      >
        Mushroom
      </a>
      <a
        className="selectable"
        href="https://jadeallencook.github.io/px-art/build/#0000022222000000000022222222200000004443313000000004343331333000000434433313330000004333311110000000033333300000000022622622000000022262262220000022226666222200003326466462330000333666666333000033666666663300000066600666000000044400004440000044440000444400"
      >
        Mario
      </a>
      <a
        className="selectable"
        href="https://jadeallencook.github.io/px-art/build/#0000001111000000000001222210000000111222222111000122202222222210012200022222221001222022222222101222222222222221112222211222221110112210012211011000110000110001010000100100001001000001100000100100000000000010001110000001110000000100001000000000001111000000"
      >
        Poke Ball
      </a>

      <a
        className="selectable"
        href="https://jadeallencook.github.io/px-art/build/#0000055555500000000055555555000000405333333504000040333333330400004434544543440000443434434344000004444444444300000554433445530003333344445533303343333555554330344433433554443033433345333344403343334335555400333333455555000004444430033300000000333000000000"
      >
        Zelda
      </a>
    </div>
  );
}
